import React, { useState } from 'react'
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import SaveIcon from '@material-ui/icons/Save';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { ProductInputData, ProductInputDataRequiredFields, Clampex } from '../../redux/product/productTypes';
import { ClampexType } from '../../types/types';
import SaveDialog from './SavedSelectionDialog';
import SaveSelection from '../../service/SaveSelectionToLocalBrowser';
import { useSnackbar, VariantType } from 'notistack';
import { useIntl } from 'react-intl';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            '@media (max-width: 600px)': {
                width: '80%'
            },
            //@ts-ignore
            backgroundColor: theme.palette.third.main,
        },
        grid: {
            textAlign: "center",
            padding: "5px"
        },
        rightIcon: {
            marginLeft: theme.spacing(1),
        }
    }),
);

interface Props {
    clampexType: ClampexType,
    productInputData: ProductInputData,
    calculate(clampexType: ClampexType, productInputData: ProductInputData): any,
    updateRequiredValue(productInputDataRequiredFields: ProductInputDataRequiredFields): any,
    inputChanged(productInputData: any): any,
    updateProduct(product: ClampexType): any,
    currentProduct: Clampex
}

/**
 * This method checks all input variables for null (if they are filled in the UI)
 * If one of the attribute is null it will dispatch a new action to redux and fill a dedicated store variable
 * with true, so that i can display "required" text under the textbox.
 * @param obj the object with all input variables from redux store
 * @param setNull the method that will be executed if some attribute is null
 */
const checkRequiredFields = (obj: any, setNull: any, type: ClampexType): boolean => {
    setNull({});
    let isSomeValueNull: boolean = false;

    let productInputDataRequiredFields: any;

    for (var key in obj) {
        //quick and dirty ! Nur bei KTR150 wird aus Schraubenanzugsmoment -> Schraubenvorspannkraft.
        // Damit kein Fehler durch fehlenden wert verursacht wird, wird der fehler hier einfach abgefangen.
        if (type === ClampexType.KTR150 && key === "screwBoltingTorque_Ts") {
                //mache nichts
                //irgendwie hat die negation im if nicht funktioniertß1
        }
        else {
            var value = obj[key];
            if (value === null || value === undefined) {
                isSomeValueNull = true;
                productInputDataRequiredFields = { ...productInputDataRequiredFields, [key]: true }
            } else {
                //we have to set it to false for the second time the user is using the same page it will not be refreshed.
                productInputDataRequiredFields = { ...productInputDataRequiredFields, [key]: false }
            }
        }
    }
    setNull(productInputDataRequiredFields);
    return isSomeValueNull;
}



export default function ControlButtons(props: Props) {

    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { formatMessage: f } = useIntl();

    const handleClickOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    /************************************
     * This is the main calculation method.
     * it also checks if all fields are filled
     ***********************************/
    const onCalculationClick = () => {
        // wenn schraubenvorspannkraft vom user nicht gesetzt wurde nehme das was aus der db kommt
        if (props.productInputData.screwBoltingTorque_Ts === null || props.productInputData.screwBoltingTorque_Ts === undefined) {
            // props.productInputData.screwBoltingTorque_Ts = props.currentProduct.screwBoltingTorque_Ts;
            // props.productInputData.screwBoltingTorqueOverwritePercentage = 0;
        }

        //if checkrequiredFields is false we can calulcate
        if (!checkRequiredFields(props.productInputData, props.updateRequiredValue, props.currentProduct.type)) {
            props.calculate(props.clampexType, props.productInputData);
        }
    }

    /************************************
     * Save current selection in local browser storage
     ************************************/
    const saveSelection = () => {
        SaveSelection(props.clampexType, props.productInputData);
        const variant: VariantType = "success";
        enqueueSnackbar(f({ id: 'app.saveSelection.success', defaultMessage: 'Saved successfully' }), { variant });
    }
    /*************************************
     * Load selection from modal into current window
     * @param selection The selection to load
     *************************************/
    const loadSelection = (selection: ProductInputData) => {
        console.log(selection);
        props.inputChanged(selection);
        setOpen(false);
        const variant: VariantType = "success";
        enqueueSnackbar(f({ id: 'app.loaddialog.success', defaultMessage: 'Selection successfully loaded.' }), { variant });
    }
    /**********************************
     * This function deletes all input fields
     *********************************/
    const deleteInputs = () => {
        props.inputChanged({
            c_value: null,
            hubInnerDiameter_D: null,
            hubOuterDiameter: null,
            torque: null,
            axialForce: null,
            rotationSpeed: null,
            yieldStrengthShaft: null,
            shaftDiameter_d: null,
            shaftInnerDiameter_diw: null,
            yieldStrengthHub: null,
            materialDensityHub: null,
            hubWidth: null,
            screwBoltingTorqueOverwritePercentage: 0,
            screwBoltingTorque_Ts: null,
            clampingForce_PA: null,
        });
    }

    //Auskommentiert (War das vielleicht ein test?!)
    //props.updateProduct(props.clampexType);

    return (
        <Grid container>
            <Grid item xs={12} sm={6} md={4} className={classes.grid}>
                <Button onClick={saveSelection} className={classes.button} variant="contained" color="secondary">
                    {f({ id: "app.controlbuttons.save" })}
                    <SaveIcon className={classes.rightIcon} />
                </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                <Button onClick={handleClickOpen} className={classes.button} variant="contained" color="secondary">
                    {f({ id: "app.controlbuttons.load" })}
                    <GetAppIcon className={classes.rightIcon} />
                </Button>
                <SaveDialog clampexType={props.clampexType} loadSelection={loadSelection} onClose={handleClose} open={open} />
            </Grid>
            <Grid item xs={12} sm={6} md={2} className={classes.grid}>
                <Button onClick={deleteInputs} className={classes.button} variant="contained" color="secondary">
                    {f({ id: "app.controlbuttons.delete" })}
                    <DeleteIcon className={classes.rightIcon} />
                </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                <Button onClick={onCalculationClick} className={classes.button} variant="contained" color="secondary">
                    {f({ id: "app.controlbuttons.process" })}
                    <KeyboardArrowRightIcon className={classes.rightIcon} />
                </Button>
            </Grid>
        </Grid>
    )
}
